import React from "react";
import { useNavigate } from "react-router-dom";
import { FaStore, FaBuilding } from "react-icons/fa";

const SellerProduct = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Sale by Seller",
      desc: "You manage products, pricing, and orders directly.",
      path: "/sale-by-seller",
      icon: <FaStore size={28} className="text-green-600" />,
    },
    {
      title: "Sale by OGCS",
      desc: "OGCS helps manage sales, visibility, and delivery flow.",
      path: "/sale-by-ogcs",
      icon: <FaBuilding size={28} className="text-blue-600" />,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 flex items-center justify-center">
      <div className="w-full max-w-4xl">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Choose Selling Mode
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Select how you want to sell your products.
            </p>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 text-gray-700"
          >
            Back
          </button>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {cards.map((c) => (
            <div
              key={c.title}
              onClick={() => navigate(c.path)}
              className="bg-white border border-gray-200 rounded-xl p-6 cursor-pointer hover:shadow-md transition"
            >
              {/* Logo */}
              <div className="mb-4">{c.icon}</div>

              {/* Title */}
              <h2 className="text-lg font-semibold text-gray-900">
                {c.title}
              </h2>

              {/* Description */}
              <p className="text-sm text-gray-600 mt-2">
                {c.desc}
              </p>

              {/* CTA */}
              <div className="mt-5">
                <span className="text-sm font-semibold text-blue-600">
                  Continue →
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-gray-500 mt-6">
          Tip: Start with “Sale by Seller” if you want full control.
        </p>

      </div>
    </div>
  );
};

export default SellerProduct;